module.exports = __webpack_public_path__ + "img/Icon_info_Start.20befded.png";